module.exports = __webpack_public_path__ + "NanumSquareEB.0029b8a5a16ce106b0bf";


//////////////////
// WEBPACK FOOTER
// /Users/gygo/zzal/src_brand_web/src/assets/font/NanumSquareEB.woff
// module id = ../../../../../src/assets/font/NanumSquareEB.woff
// module chunks = styles